import {utils} from "../../network/utils";


const chineseNum = ['一','二','三','四','五','六']


function toGradeString(gradeVal){
    let ret;
    if(gradeVal<=6){ //小学
        ret = chineseNum[gradeVal-1]
        ret += '年级'
    }else if(gradeVal<=9){  //初中
        ret = '初'
        ret += chineseNum[gradeVal-7]
    }else if(gradeVal<=12){ //高中
        ret = '高'
        ret += chineseNum[gradeVal-10]
    }else{
        ret = '大学'
    }
    return ret
}

function toAge(birthday){
    var date = new Date()
    var year = date.getFullYear()
    var birYear = parseInt(birthday/10000)
    return year-birYear;
}

//剩余时间
function remainingTime(artTime){
    var curData = new Date();
    var curTick = parseInt(curData.getTime())
    // console.log(utils.date('Y-m-d', artTime/1000))
    // console.log(utils.date('Y-m-d', curTick/1000))
    // console.log(artTime)
    // console.log(curTick)

    if(curTick>artTime){
        var delT = curTick-artTime
        //分钟
        delT = parseInt(delT/1000/60);
        // console.log(delT)
        var str=''
        //年
        if(parseInt(delT/(365*24*60))>0){
            str=parseInt(delT/(365*24*60))
            str+='年前'
        }
        //月
        else if(parseInt(delT/(30*24*60))>0){
            str=parseInt(delT/(30*24*60))
            str+='月前'
        }
        //天
        else if(parseInt(delT/(24*60))>0){
            str=parseInt(delT/(24*60))
            str+='天前'
        }
        //小时
        else if(parseInt(delT/(60))>0){
            str=parseInt(delT/(60))
            str+='小时前'
        }
        //分钟
        else{
            str=parseInt(delT)
            str+='分钟前'
        }
        return str
    }
    else{
        return '刚刚'
    }
}

function jsonToString(str, num, brake='、'){
    let arr = JSON.parse(str)
    return arrayToString(arr, num, brake)
}
function arrayToString(arr, num, brake='、'){
    let max = arr.length>num?num:arr.length
    let str = ''
    for (let i=0; i<max; i++){
        if(str!=''){
            str += brake
        }
        str += arr[i]
    }
    return str
}

export const actUtil = {
    toGradeString, toAge, remainingTime,arrayToString,jsonToString
};
